import { Component, OnInit } from '@angular/core';
import { RecentlyViewedItem, RecentlyViewedService } from '../../services/recently-viewed.service';

@Component({
  selector: 'app-recently-viewed',
  standalone: false,
  templateUrl: './recently-viewed.component.html',
  styleUrl: './recently-viewed.component.css',
})
export class RecentlyViewedComponent implements OnInit {

  constructor(public rv: RecentlyViewedService) {}

  ngOnInit(): void {
    // Refresh from localStorage on every mount (handles page reloads)
    this.rv.loadItems();
  }

  get items(): RecentlyViewedItem[] {
    return this.rv.items;
  }

  /** Extract the path portion of a URL (before any query string). */
  getPath(url: string): string {
    return url.split('?')[0];
  }

  /** Parse query params from a URL string into an object for [queryParams]. */
  getQueryParams(url: string): { [key: string]: string } | null {
    const qs = url.split('?')[1];
    if (!qs) return null;
    const params: { [key: string]: string } = {};
    new URLSearchParams(qs).forEach((v, k) => params[k] = v);
    return params;
  }

  timeAgo(ts: number): string {
    const diff = Date.now() - ts;
    const mins = Math.floor(diff / 60_000);
    if (mins < 1)   return 'Just now';
    if (mins < 60)  return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    if (hours < 48) return 'Yesterday';
    return `${Math.floor(hours / 24)}d ago`;
  }

  clearAll(event: MouseEvent): void {
    event.preventDefault();
    this.rv.clear();
  }
}
